/* DsMaster: store-wide behavior on top of Dawn. Loaded from layout/theme.liquid. */

/* Buy now straight to checkout through a cart link (theme setting "Buy now goes straight to checkout").
   A section with a bundle (snippets/dm-bundle.liquid) always goes this way, so its extra items come along.
   Capture phase, so it runs before Dawn's add-to-cart. */
document.addEventListener('submit', (e) => {
  const pf = e.target.closest('product-form');
  if (!pf) return;
  const bundle = (pf.closest('.shopify-section') || document).querySelector('[data-dm-bundle]');
  if (document.body.dataset.dmSkipCart !== 'true' && !bundle) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  const button = pf.querySelector('[type="submit"]');
  const id = pf.querySelector('input[name="id"]')?.value;
  if (!id || button?.getAttribute('aria-disabled') === 'true') return;
  const extras = bundle?.dmExtras ? bundle.dmExtras() : [];
  if (extras === null) return; // an extra item still needs a pick: the bundle shows the prompt
  const counts = new Map([[String(id), 1]]);
  extras.forEach((x) => {
    const key = x === 'same' ? String(id) : String(x);
    counts.set(key, (counts.get(key) || 0) + 1);
  });
  button.setAttribute('aria-disabled', true);
  button.classList.add('loading');
  pf.querySelector('.loading__spinner')?.classList.remove('hidden');
  window.location = `/cart/${[...counts].map(([k, n]) => `${k}:${n}`).join(',')}`;
}, true);

/* Not every combo exists (e.g. XS only in some colors). Picking a value that doesn't go with the other
   selected values would show "Unavailable" and keep the old photo, so before Dawn reads the picker
   (capture phase), move the other options to the nearest combo that exists. */
document.addEventListener('change', (e) => {
  const input = e.target;
  const picker = input.closest?.('variant-selects');
  const json = picker?.querySelector('[data-dm-variants]');
  if (!json || input.type !== 'radio') return;
  const variants = JSON.parse(json.textContent);
  const groups = [...picker.querySelectorAll('fieldset')];
  const selected = groups.map((g) => g.querySelector('input:checked')?.value);
  if (variants.some((v) => v.options.every((o, i) => o === selected[i]))) return;
  const changed = groups.findIndex((g) => g.contains(input));
  const valuesOf = (i) => [...groups[i].querySelectorAll('input')].map((x) => x.value);
  const distance = (v) => v.options.reduce((sum, o, i) => {
    if (i === changed) return sum;
    const vals = valuesOf(i);
    return sum + Math.abs(vals.indexOf(o) - vals.indexOf(selected[i]));
  }, 0) + (v.available ? 0 : 0.5);
  const best = variants.filter((v) => v.options[changed] === input.value).sort((a, b) => distance(a) - distance(b))[0];
  if (!best) return;
  best.options.forEach((o, i) => {
    if (i === changed) return;
    const radio = [...groups[i].querySelectorAll('input')].find((x) => x.value === o);
    if (radio) radio.checked = true;
  });
}, true);
